module.exports = __webpack_public_path__ + "img/shape-23.2402b4de.svg";